import { DrillDifficulty, TrainingDrill, AgeGroup } from '../Model';

export type SortOption = 'name' | 'duration-asc' | 'duration-desc' | 'difficulty-asc' | 'difficulty-desc';

export const difficultyOrder: Record<DrillDifficulty, number> = {
  'Beginner': 1,
  'Intermediate': 2,
  'Advanced': 3,
};

export const sortDrills = (drills: TrainingDrill[], sortBy: SortOption): TrainingDrill[] => {
  return [...drills].sort((a, b) => {
    switch (sortBy) {
      case 'name':
        return a.name.localeCompare(b.name);
      case 'duration-asc':
        return a.duration - b.duration;
      case 'duration-desc':
        return b.duration - a.duration;
      case 'difficulty-asc':
        return difficultyOrder[a.difficulty] - difficultyOrder[b.difficulty];
      case 'difficulty-desc':
        return difficultyOrder[b.difficulty] - difficultyOrder[a.difficulty];
      default:
        return 0;
    }
  });
};

export const filterDrills = (
  drills: TrainingDrill[],
  searchQuery: string,
  filterDifficulty: DrillDifficulty | 'All',
  filterCategory: string,
  filterAgeGroup: AgeGroup | 'All' = 'All'
): TrainingDrill[] => {
  return drills.filter(drill => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const matchesName = drill.name.toLowerCase().includes(query);
      const matchesDescription = drill.description.toLowerCase().includes(query);
      const matchesSkills = drill.skills.some(skill => skill.toLowerCase().includes(query));
      const matchesAgeGroups = drill.ageGroups?.some(ag => ag.toLowerCase().includes(query));
      if (!matchesName && !matchesDescription && !matchesSkills && !matchesAgeGroups) return false;
    }
    if (filterDifficulty !== 'All' && drill.difficulty !== filterDifficulty) return false;
    if (filterCategory !== 'All' && drill.category !== filterCategory) return false;
    if (filterAgeGroup !== 'All' && (!drill.ageGroups || !drill.ageGroups.includes(filterAgeGroup))) return false;
    return true;
  });
};
